<div class="modal-content">
    <div class="modal-header border-0">
        <h5 class="modal-title" id="modulesModalLabel">Asiganr vehículo</h5>
        <button type="button" class="btn-close" (click)="modal.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <form novalidate [formGroup]="vehicleForm">
            <div class="mb-3">
                <label class="col-12 form-label m-0" for="vehicle_id">Vehículo <span class="txt-danger"> *</span></label>
                <select class="col-12 form-select" id="vehicle_id" required formControlName="vehicle_id"
                        [ngClass]="{ 'is-invalid' : (vehicle?.touched || validate) && vehicle?.errors, 'is-valid' : !vehicle?.errors}">
                    <option [ngValue]="null" disabled selected>Vehículo</option>
                    <option *ngFor="let vehicle of vehiclesLis" [value]="vehicle.id">{{ vehicle.niv }} - {{vehicle.brand}} - {{vehicle.subbrand}}</option>
                </select>
                @if (vehicle?.errors) {
                    <div class="invalid-feedback">Selecciona un vehículo</div>
                }
            </div>
        </form>
    </div>
    <div class="modal-footer border-0 pt-3">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismissAll()">Cerrar</button>
        <button type="button" class="btn btn-primary" (click)="assignVehicle()">Asignar Vehículo</button>
    </div>
</div>
